


import React, { Component } from "react";
import Button from "../../components/bases/button/button";

import imgsearch from "./assets/search.png"

class TableInput extends React.Component
{
    
    constructor(props)
    {
        super(props);
        this.state =
        {
            value: this.props.value,
            liste: [],
            listeloaded: false,
            lib: "",
            image:"",
            errmsg: this.props.errmsg,
        }


        this.onListLoaded = this.onListLoaded.bind(this)

    }


    onListLoaded(datas)
    {
        this.setState({listeloaded:true, liste: datas})
        console.log(datas)
    }


    componentDidMount()
    {
        if (!this.state.listeloaded)
            this.props.api(this.onListLoaded)
    }


    componentMustRefresh()
    {
        this.props.api(this.onListLoaded)
    }    
    setValue(value)
    {
        this.props.api(this.onListLoaded)
        this.setState({value:value})
    }


    getValue()
    {


        for (var i=0; i < this.state.liste.length; i++)
        {
                if (this.state.liste[i][this.props.tableid] == this.state.value)
                    return this.state.value;        
        }
        return 0;
    }

    render()
    {
        var msg="";
        if (this.state.errmsg != "")
        {
            msg=(
                <span style={{borderRadius:"3px",marginLeft:"12px",color:"white", borderStyle:"solid", borderColor:"red", borderWidth:"1px"}}
                    >
                &nbsp;&nbsp;{this.state.errmsg}&nbsp;&nbsp;
                </span>
            )
        }

        var msg="";
        var image="";
        if (this.state.value == 0)
            msg = this.props.unselect;
        else
        {
            for (var i=0; i < this.state.liste.length; i++)
            {
                if (this.state.liste[i][this.props.tableid] == this.state.value)
                {
                    msg = this.state.liste[i][this.props.tablename];
                    image = this.state.liste[i][this.props.tableimage];

                    if (image !="")
                    {
                        msg = (
                            <>
                            {<img src={image} height={22} style={{verticalAlign:"middle"}}/>}
                            &nbsp;{msg}
                            </>
                        )
                    }
                    break;
                }
            }
            if (msg ==="") msg = this.props.unselect;

        }
            



        return (<>
            <div className = "dialog-Input-Title">
                {this.props.title}
            </div>

            <div style={{display:"flex", flexDirection:"row"}}>
                <div className="dialog-Table-Datas" style={{width: this.props.width - 32}}>
                    {msg}
                </div>
                <div>
                <Button tooltip={this.props.tooltip} 
                    image={imgsearch} width={20} height={20} disable={this.props.readOnly}
                    button={true} onClick={ () =>this.props.onselect(this.state.value)} 
                    />
                </div>
            </div>
            

            
        </>);
    
    }

}
TableInput.defaultProps = 
{
    align: "left",
    image: "",
    lib: "",
    disabled: false,
    errmsg: "",
}

export default TableInput